import React, { ForwardedRef, forwardRef } from 'react'
import { Select as AntSelect } from 'antd'
import { SelectValue } from 'antd/lib/select'
import cl from 'classnames'
import { BaseSelectRef } from 'rc-select'

import { Icon, Input } from 'Shared/atoms/index'
import { usePopupContainer } from 'Shared/hooks/usePopupContainer'

import { Props } from './types'

import styles from './styles.module.scss'

const Select = forwardRef<BaseSelectRef, Props<SelectValue>>(
	<T extends SelectValue>(
		{
			className,
			dataTestId,
			allowClear,
			showArrow,
			isReadOnly,
			...props
		}: React.PropsWithChildren<Props<T>>,
		ref: ForwardedRef<BaseSelectRef>
	) => {
		const getPopupContainer = usePopupContainer(dataTestId)

		if (isReadOnly) {
			return (
				<Input
					value={
						props?.value?.label
							? (props.value as LabelValue).label
							: props?.options?.find(({ value }) => value === props.value)?.label ??
							  ''
					}
					isNonEditable={true}
				/>
			)
		}

		return (
			<AntSelect<T>
				{...props}
				popupClassName={cl(styles.basicSelect, props.popupClassName)}
				className={cl(styles.basicSelect, className)}
				getPopupContainer={
					props.getPopupContainer ? props.getPopupContainer : getPopupContainer
				}
				ref={ref}
				virtual={false}
				suffixIcon={
					showArrow ? <Icon className={styles.suffixIcon} type="arrowDropdown" /> : null
				}
				allowClear={
					allowClear && {
						clearIcon: <Icon className={styles.suffixIcon} type="closeCircle" />
					}
				}
			/>
		)
	}
)

export default Select
